<template>
  <generic-modal :title="$t('documents')" ref="generic_modal" size="fullscreen">
    <!-- <pre>{{ documents }}</pre> -->
    <article class="message is-info" v-if="!documents.length">
      <div class="message-body">
        {{ $t("no documents loaded yet") }}
      </div>
    </article>
    <div class="grid">
      <div class="column" v-for="(docmnt, didx) in documents" :key="didx">
        <div class="card">
          <!-- <header class="card-header">
            <div class="card-header-title">
              {{ docmnt.name }}
            </div>
            <div class="car-header-subtitle">sdfsfd</div>
            <a
              class="card-header-icon"
              aria-label="more options"
              @click="delete_document(docmnt.uuid)"
            >
              <span class="icon">
                <i class="fa fa-trash"></i>
              </span>
            </a>
          </header> -->
          <div class="card-content">
            <div class="content">
              <a
                class="is-pulled-right"
                aria-label="more options"
                :data-tooltip="$t('delete')"
                @click="delete_document(docmnt.uuid)"
              >
                <span class="icon has-text-danger">
                  <i class="fa fa-trash"></i>
                </span>
              </a>
              <div class="title is-5">
                {{ docmnt.name }}
              </div>
              <div class="subtitle is-6">
                {{ format_date(docmnt.create_date) }}
              </div>
              <div v-if="docmnt.settings && docmnt.settings.photos">
                <ul>
                  <li
                    v-for="(photo, pidx) in docmnt.settings.photos"
                    :key="pidx"
                  >
                    <div class="buttons are-small is-pulled-right">
                      <!-- <div
                        class="button"
                        aria-label="more options"
                        :data-tooltip="$t('delete')"
                        @click="delete_document(docmnt.uuid)"
                      >
                        <span class="icon has-text-danger">
                          <i class="fa fa-trash"></i>
                        </span>
                      </div> -->
                      <div
                        class="button"
                        aria-label="more options"
                        :data-tooltip="$t('download')"
                        @click="download_photo(photo)"
                      >
                        <span class="icon has-text-warning">
                          <i class="fa fa-download"></i>
                        </span>
                      </div>
                    </div>

                    <div class="title is-6">{{ photo.file.file.name }}</div>
                    <div class="subtitle is-6">
                      {{ photo.mimetype }} ({{
                        translate_file_size(photo.size)
                      }})
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="notification is-danger mt-5" v-if="error" v-html="error"></div>
    <template v-slot:footer>
      <!-- <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon"`>
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button> -->
      <button
        class="button is-primary is-rounded"
        @click="
          $emit('create_document', medical_service_uuid);
          close_modal();
        "
      >
        <span class="icon">
          <i class="fa fa-plus"></i>
        </span>
        <span>{{ $t("create") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("close") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  del,
  confirm_deletion_dialog,
  api_host,
  get,
  post,
  error_alert,
  translate_file_size,
  generate_error_message_text,
  get_currency_settings,
  format_date,
  format_currency,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericCalendar from "@/components/generic_calendar/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import moment from "moment";

export default {
  name: "DocumentsModal",
  components: {
    GenericModal,
    GenericCalendar,
    GenericDropdown,
  },
  data() {
    return {
      medical_service_uuid: "",
      documents: [],
      error: "",
    };
  },
  computed: {
    // is_form_invalid() {
    //   let v = this;
    //   return false;
    //   // return !v.meta.patient_id || !v.meta.start_date;
    // },
    // total() {
    //   let v = this;
    //   if (v.attentions && v.attentions.length) {
    //     return v.attentions.reduce((acc, cur) => acc + Number(cur.price), 0);
    //   } else {
    //     return 0;
    //   }
    // },
  },
  methods: {
    translate_file_size,
    format_date,
    format_currency,
    refresh() {
      let v = this;
      get("/patient/patient-medical-service/document", {
        uuid: v.medical_service_uuid,
      })
        .then((documents) => {
          v.documents = documents;
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal(medical_service_uuid) {
      let v = this;
      v.set_initial_state();

      if (medical_service_uuid) {
        v.medical_service_uuid = medical_service_uuid;
        // v.uuid = product_uuid;
        v.refresh();
        v.$refs.generic_modal.show_modal();
      } else v.$refs.generic_modal.show_modal();
    },
    set_initial_state() {
      let v = this;
      v.error = "";
    },
    delete_document(uuid) {
      let v = this;
      confirm_deletion_dialog(
        v.$t("are you sure to delete document?"),
        v,
        () => {
          del("/patient/patient-medical-service/document", { uuid: uuid })
            .then(() => {
              v.refresh();
            })
            .catch((error) => {
              error_message(error);
            });
        }
      );
    },
    download_photo(photo) {
      let v = this;
      let file_path = `${api_host}/drive/static/${photo.final_name}`;
      // download(file_path, photo.file_name);
      window.open(file_path, "_blank");
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
